export default {"src":"/_next/static/media/pdfIcon.a3b1d0fe.svg","height":20,"width":17,"blurWidth":0,"blurHeight":0};